import React from 'react';
import PrimaryTable from "../../../../Shared/components/PrimaryTable";
import { LinkProductsHead } from "../../../../../config/constant";
import { TableCell, TableRow, Checkbox } from "@mui/material";
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";

export const LinkProductTable = (props) => {
    const classes = customStyles();
    const { details, selected, onSelected, handleClick, selecedProduct } = props;
    const isSelected = (name) => selected && selected.indexOf(name) !== -1;

    return (
        <PrimaryTable
            heads={selecedProduct ? LinkProductsHead.slice(1) : LinkProductsHead}
            details={details}
            selected={selected}
            onSelected={(value) => onSelected(value)}
            component={
                <>
                    {
                        details && details.length > 0 ? details.map((data, i) => (
                            <TableRow key={i} onClick={(e) => handleClick(data.id)}>
                                {!selecedProduct &&
                                    <TableCell className={clsx('checkbox', classes.tablealign)}
                                        padding="checkbox"><Checkbox checked={isSelected(data.id)} /> </TableCell>
                                }
                                <TableCell>{`${data.productId}`}</TableCell>
                                <TableCell>{`${data.productName}`}</TableCell>
                            </TableRow>
                        )) : <TableRow><TableCell colSpan={3}>{selecedProduct ? 'Select Products To Categories' : 'All Products Are Categorized'}</TableCell></TableRow>
                    }
                </>
            }
        />
    )
}